import {
  GETCUSTOMERIDANDNAMELIST_SUCCESS,
  GETCUSTOMERIDANDNAMELIST_FAILED,
  RESET_GETCUSTOMERIDANDNAMELIST,
  LOADING_GETCUSTOMERIDANDNAMELIST,
  NETWORK_ERROR_GETCUSTOMERIDANDNAMELIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETCUSTOMERIDANDNAMELIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETCUSTOMERIDANDNAMELIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETCUSTOMERIDANDNAMELIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETCUSTOMERIDANDNAMELIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETCUSTOMERIDANDNAMELIST:
      return (state = initialState);
    default:
      return state;
  }
};
